import React from 'react'

function Button({href="#", children, className, type="cta"}) {
    const  colorScheme = {
        "cta": "text-white border-brand bg-brand hover:bg-white hover:border-white hover:text-brand",
        "cta-border": "text-white border-brand bg-brand hover:bg-white hover:text-brand",
        "ghost": "text-white border-white bg-none hover:text-brand hover:bg-white"
    }

  return (
    <a className={`py-3 outline-none px-12 border-2 text-base cursor-pointer rounded-full font-normal transition-all duration-200 ${colorScheme[type]} ${className}`} href={href}>{children}</a>
  )
}

export default Button